import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import { noop } from 'lodash-es';
import { border, borderColor, borderStyle } from 'styled-system';
import type { BorderColorProps, BorderProps, BorderStyleProps, WidthProps } from 'styled-system';

import Code from 'common/components/Voucher/Code';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { SpaceProps } from 'common/theme/system-types';

type VoucherCodeProps = { voucherCode: Nullable<string>; onClick?: () => void };

const InnerVoucherCode = styled(Code)<
  BorderProps & BorderStyleProps & BorderColorProps & SpaceProps & WidthProps
>`
  ${border};
  ${borderStyle};
  ${borderColor};
`;

const innerVoucherCodeStyles: ComponentProps<typeof InnerVoucherCode> = {
  bgColor: 'white',
  textColor: 'black',
  border: '1px',
  borderStyle: 'solid',
  borderColor: 'sys.neutral.border.inactive',
  m: 'sp_0',
  py: 'sp_4',
  px: 'sp_8',
};

const VoucherCode = ({ voucherCode, onClick = noop }: VoucherCodeProps) => {
  const { t } = useLocalization();

  if (!voucherCode) return null;

  return (
    <InnerVoucherCode
      {...innerVoucherCodeStyles}
      my="sp_0"
      width="fit-content"
      code={voucherCode}
      label={t('h24_voucher_code_banner_label')}
      onClick={onClick}
    />
  );
};

export default VoucherCode;
